export { default as DeliveryAddresses } from './delivery-addresses';
